<template>
  <span class="p-1">
    <b-dropdown aria-role="list" position="is-bottom-left">
      <b-button role="button" slot="trigger" class="is-danger is-inverted">
        <b-icon size="is-small" icon="block-helper"></b-icon>
      </b-button>

      <b-dropdown-item
        aria-role="listitem"
        @click="actionSuccess('User has been blocked')"
        ><b-icon size="is-small" type="is-danger" icon="account-cancel"></b-icon> Block
        user</b-dropdown-item
      >
      <b-dropdown-item
        aria-role="listitem"
        @click="
          actionSuccess(
            'Report sent. Costuto team will review it as soon as possible ...'
          )
        "
        ><b-icon size="is-small" type="is-danger" icon="alert-octagon"></b-icon> Report
        user</b-dropdown-item
      >
    </b-dropdown>
  </span>
</template>

<script>
import { notificationMixin } from '@/mixins/notificationMixin'

export default {
  mixins: [notificationMixin]
}
</script>
